// import React, { useEffect, useRef, useState } from "react";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import { withSnackbar } from "notistack";
// import { GetApp as IconExport } from "@mui/icons-material";

// import Loader from "components/Custom/Loader";
// import AutoComplete from "components/Custom/AutoComplete";
// import Btn from "components/Custom/Btn";

// import { NOTIFY } from "common/config";
// import { COLORS } from "common/colors";
// import { CONFIRMS, LABELS, SUCCESS, ERRORS, WARNINGS } from "common/lables";

// import { REPORTS_APIs } from "apihandlers/reports";
// import { COMMON_JS } from "common/scripts";
// import { IconButton, Tooltip } from "@mui/material";

// const MainCategorySaleReport = (props: any) => {
//   const [loading, setLoading] = useState(true);
//   const [projects, setProjects] = useState([]);
//   const [chartData, setChartData] = useState<any>({});

//   useEffect(() => {
//     if (loading) {
//       getProjects();
//     }
//   }, [loading]);

//   const getProjects = () => {
//     const args = { dropdown: true };
//     // API_HANDLER_HOME.getProjects(args).then((res) => {
//     //   const response: any = res.response;
//     //   const { status } = res;
//     //   if (status === 200) {
//     //     setProjects(response.records);
//     //   }
//     //   setLoading(false);
//     // });
//     setLoading(false);
//   };

//   const loadChart = () => {
//     // const projectId = projectRef.current.selectedValue.id;
//     // if (!projectId) {
//     //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.PROJECT_EMPTY);
//     //   return;
//     // }
//     const args = {
//       fromDt: "2023-04-01 00:00:00",
//       toDt: "2024-04-01 00:00:00",
//     };
//     setChartData(null);
//     REPORTS_APIs.getMainCategorySalesReport(args).then((res) => {
//       const response: any = res.response;
//       const { status } = res;
//       if (status === 200) {
//         setTimeout(() => {
//           setChartData(response);
//         }, 2000);
//       } else {
//         setChartData({});
//         COMMON_JS.showNotify(props, NOTIFY.ERROR, res.error);
//       }
//     });
//   };

//   const exportHighchart = () => {
//     // let projectName = "";
//     // if (projectRef.current) {
//     //   projectName = projectRef.current.selectedValue.label;
//     // }
//     let title = LABELS.MAIN_CATEGORY_WISE_SALES;
//     let header = "<html>";
//     header +=
//       "<head><title>" +
//       title +
//       "</title><style>@page{margin-top: 5;size: A3 landscape;}</style></head>";
//     let body = "<body><h2 style='text-align: center;'>" + title + "</h2>";
//     body += chartRef.current.container.current.innerHTML;
//     body += "</html>";
//     const html = header + body;
//     const printWin = window.open("", "", "toolbar=0,scrollbars=0,status=0");
//     printWin.document.write(html);
//     printWin.document.close();
//     printWin.focus();
//     printWin.print();
//     printWin.close();
//   };

//   // const orgRef: any = useRef();
//   const projectRef: any = useRef();
//   let chartRef: any = useRef();
//   const taskRef: any = useRef();
//   let projectName = "Main Category";
//   // if (projectRef.current) {
//   //   projectName = projectRef.current.selectedValue.label;
//   // }

//   const chartTitle1 = projectName;

//   const options1 = {
//     chart: {
//       plotBackgroundColor: null,
//       plotBorderWidth: null,
//       plotShadow: false,
//       type: "pie",
//       // width: window.innerWidth * 0.9,
//       // height: 550,
//       marginTop: 40,
//       marginLeft: 85,
//       height: 1000 / 1.75,
//       width: 1410 / 2,
//     },
//     credits: false,
//     title: {
//       text: chartTitle1,
//     },
//     exporting: {
//       filename: chartTitle1,
//     },
//     tooltip: {
//       pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
//     },
//     accessibility: {
//       point: {
//         valueSuffix: "%",
//       },
//     },
//     plotOptions: {
//       pie: {
//         colors: [
//           "#50B432",
//           "#ED561B",
//           "#DDDF00",
//           "#24CBE5",
//           "#64E572",
//           "#FF9655",
//           "#FFF263",
//           "#6AF9C4",
//         ],
//         allowPointSelect: true,
//         cursor: "pointer",
//         dataLabels: {
//           enabled: true,
//           format: "<b>{point.name}</b>: {point.percentage:.1f} %",
//         },
//         showInLegend: true,
//         size: "75%",
//       },
//     },
//     series: [
//       {
//         name: "Resource",
//         colorByPoint: true,
//         data: chartData ? chartData.series1 : [],
//       },
//     ],
//   };

//   return (
//     <React.Fragment>
//       <div className="pageInfo">
//         <ul className="breadcrumbs">
//           <li>{LABELS.HOME}</li>
//           <li className="dim">{" / "}</li>
//           <li onClick={() => props.setDashMenu(LABELS.HOME)}>
//             {LABELS.DASHBOARD}
//           </li>
//           <li className="dim">{" / "}</li>
//           <li className="active">{LABELS.MAIN_CATEGORY_WISE_SALES}</li>
//         </ul>
//         <h4>{LABELS.MAIN_CATEGORY_WISE_SALES}</h4>
//       </div>
//       {loading ? (
//         <div className="flexCenter" style={{ minHeight: 450 }}>
//           <Loader />
//         </div>
//       ) : (
//         <div
//           className="hChart"
//           style={{
//             paddingBottom: 50,
//           }}
//         >
//           <div id="chartForm">
//             {/* <div className="formGroup">
//               <label>{LABELS.PROJECT_NAME}</label>
//               <AutoComplete
//                 id={"projects"}
//                 list={projects}
//                 childRef={projectRef}
//                 disabled={!chartData}
//               />
//             </div> */}

//             <div
//               className="formGroup"
//               style={{
//                 display: "flex",
//                 marginTop: 15,
//                 marginBottom: 25,
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "row",
//                   alignItems: "center",
//                 }}
//               >
//                 <Btn
//                   text={LABELS.LOAD}
//                   onClick={loadChart}
//                   loading={!chartData}
//                   marginRight={15}
//                 />
//                 {chartData && chartData.series1 && (
//                   <Tooltip title={LABELS.EXPORT_TO_PDF}>
//                     <IconButton
//                       disabled={chartData === null}
//                       onClick={exportHighchart}
//                     >
//                       <IconExport />
//                     </IconButton>
//                   </Tooltip>
//                 )}
//               </div>
//             </div>
//           </div>

//           {chartData ? (
//             <div
//               style={{
//                 width: "98%",
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "space-between",
//               }}
//             >
//               <div
//                 style={{
//                   width: "98%",
//                   display: "flex",
//                   flexDirection: "row",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <div style={{ width: "49%" }}>
//                   <HighchartsReact
//                     highcharts={Highcharts}
//                     options={options1}
//                     ref={chartRef}
//                   />
//                 </div>
//               </div>
//             </div>
//           ) : (
//             <div
//               className="flexCenter"
//               style={{ minHeight: 400, width: "100%" }}
//             >
//               <Loader />
//             </div>
//           )}
//         </div>
//       )}
//     </React.Fragment>
//   );
// };

// export default withSnackbar(MainCategorySaleReport);

import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import { NOTIFY } from "common/config";
import { LABELS, WARNINGS, TITLES, SUB_TITLES } from "common/lables";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";

import { MASTER_APIs } from "apihandlers/master";
import { REPORTS_APIs } from "apihandlers/reports";
import { COLORS } from "common/colors";

const MainCategorySaleReport = (props: any) => {
  const { setDashMenu } = props;

  const outletRef: any = useRef();

  const [loading, setLoading] = useState(true);
  const [masters, setMasters] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "billNumber",
      name: LABELS.BILL_NUMBER,
      width: "30%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },

    {
      key: "time",
      name: LABELS.TIME,
      width: "30%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "total",
      name: LABELS.TOTAL,
      width: "30%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
  ];

  useEffect(() => {
    if (loading) {
      getOrgProfile();
    }
  }, [loading]);

  const getOrgProfile = () => {
    const args = {
      minResponse: true,
    };
    MASTER_APIs.getPosCenters(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list: any = [{ id: -1, label: "All" }];
        let recs: any = response.records;
        for (let i = 0; i < recs.length; i++) {
          list.push({
            id: recs[i].idcenters,
            label: recs[i].name,
          });
        }
        setMasters(list);
        // setLoading(false);
      }
    });
  };

  const loadChart = () => {
    const outlet = outletRef.current.selectedValue.id;
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    const args = {
      inTime: fromDt,
      outTime: toDt,
      outlet,
      reportType: "excel",
    };
    let errors = [];
    if (!outlet) {
      errors.push({
        id: "outlet",
        msg:
          "<span class='bold'>" +
          LABELS.OUTLET +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (fromDt === "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt === "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    setRows(null);
    // setLoading(true);
    REPORTS_APIs.getPosBillRegister(args).then((res) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        for (let i = 0; i < response.rows.length; i++) {
          response.rows[i]["slNo"] = i + 1;
        }
        setRows(response.rows);
        setLoading(false);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    loadChart();
  };

  console.log("Page: MainCategorySaleReport:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.REPORTS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.MAIN_CATEGORY_WISE_SALES}</li>
        </ul>
        <h4>{TITLES.MAIN_CATEGORY_WISE_SALES}</h4>
        <p>{SUB_TITLES.MAIN_CATEGORY_WISE_SALES}</p>
      </div>
      <div className="hChart">
        <div
          style={{ width: "100%", display: "flex", flexDirection: "column" }}
        >
          {/* <div
            className="formGroup"
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: 5,
              marginBottom: 10,
              width: "40%",
            }}
          >
            <label>{LABELS.SELECT_OUTLET + " :"}</label>
            <AutoComplete
              id={"masters"}
              list={masters}
              childRef={outletRef}
              defaultValue={{ id: -1, label: "All" }}
            />
          </div> */}
          <div
            className="formGroup"
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: 0,
              marginBottom: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                marginRight: 15,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  fontWeight: "500",
                  fontSize: 14,
                  marginTop: 6,
                  marginRight: 8,
                }}
              >
                {LABELS.FROM_DATE}
              </label>
              <TxtBox
                type={"date"}
                id="fromDt"
                defaultValue={DateFunctions.getDate(
                  "today",
                  "from",
                  "YYYY-MM-DD"
                )}
              />
            </div>

            <div
              style={{
                display: "flex",
                marginRight: 15,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  fontWeight: "500",
                  fontSize: 14,
                  marginTop: 6,
                  marginRight: 8,
                }}
              >
                {LABELS.TO_DATE}
              </label>
              <TxtBox
                type={"date"}
                id="toDt"
                defaultValue={DateFunctions.getDate(
                  "thismonth",
                  "to",
                  "YYYY-MM-DD"
                )}
              />
            </div>

            <div
              style={{
                display: "flex",
                padding: 10,
                marginTop: "0.3rem",
              }}
            >
              <Btn
                text={LABELS.LOAD}
                onClick={loadChart}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </div>
        {mandatoryResults.length > 0 && (
          <div className="mandatoryBox">
            <ul>
              {mandatoryResults.map((m) => {
                return (
                  <li>
                    <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        <div className="grid excelGridWrapper">
          {!loading &&
            (rows ? (
              <ExcelGrid
                id={"mainCategorySaleReport"}
                height={window.innerHeight * 0.7}
                cols={columns}
                rows={rows}
                exportOption={true}
                newRowOption={false}
                exportName={LABELS.MAIN_CATEGORY_WISE_SALES}
                onReload={reloadGrid}
              />
            ) : (
              <div className="flexCenter" style={{ minHeight: 450 }}>
                <Loader />
              </div>
            ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(MainCategorySaleReport);
